module.exports = __webpack_public_path__ + "img/dice-2-fill.30582ae2.svg";